import React from 'react'

import { Group, Modal, Stack, Text } from '@mantine/core'
import { useElementSize } from '@mantine/hooks'
import { observer } from 'mobx-react-lite'
import { RouteComponentProps } from 'wouter'

import { FaIcon } from '#components/FaIcon'
import { useMst, useNavigation } from '#hooks'

import { HistoryAndBody } from './HistoryAndBody'
import { SnapshotLandToolbar } from './toolbar'
import { useScriptData } from './useSnapshotLandData'

const Title = ({ name }: { name?: string }) => {
  const text = name ? (
    <Text span>
      Snapshot history for&nbsp;
      <Text span fw="bold">
        {name}
      </Text>
    </Text>
  ) : (
    <Text span>Snapshot history</Text>
  )

  return (
    <Group gap={6}>
      <FaIcon icon="fa-clock-rotate-left" />
      {text}
    </Group>
  )
}

type SnapshotLandProps = RouteComponentProps<{ scriptId: string }>

export const SnapshotLand = observer<SnapshotLandProps>(({ params }) => {
  const { view } = useMst()
  const { navigate } = useNavigation()
  const scriptQuery = useScriptData(params.scriptId)
  const { ref: sizeRef, width } = useElementSize()

  const exitSnapshotLand = () => {
    navigate(view.explorerState.lastScriptPath ?? `/scripts/${params.scriptId}`)
  }

  const scriptName = scriptQuery.data?.script.name

  return (
    <Modal
      opened
      fullScreen
      variant="compact"
      data-fixed-height
      withinPortal={false}
      xOffset={20}
      yOffset={20}
      title={<Title name={scriptName} />}
      onClose={exitSnapshotLand}
      overlayProps={{ backgroundOpacity: 1 }}
    >
      <Stack h="100%" ref={sizeRef} gap={0}>
        <SnapshotLandToolbar scriptId={params.scriptId} />
        <HistoryAndBody
          scriptId={params.scriptId}
          scriptName={scriptName}
          width={width}
        />
      </Stack>
    </Modal>
  )
})
